export const GET_LICENSE_LIST = 'GET_LICENSE_LIST';
export const GET_LICENSE_LIST_SUCCESS = 'GET_LICENSE_LIST_SUCCESS';
export const GET_LICENSE_LIST_FAIL = 'GET_LICENSE_LIST_FAIL';
export const LICENSE_EXPIRING = 'LICENSE_EXPIRING';

export const GET_SYSTEM_CONFIG_LIST = 'GET_SYSTEM_CONFIG_LIST';
export const GET_SYSTEM_CONFIG_LIST_SUCCESS = 'GET_SYSTEM_CONFIG_LIST_SUCCESS';
export const GET_SYSTEM_CONFIG_LIST_FAIL = 'GET_SYSTEM_CONFIG_LIST_FAIL';

export const UPLOAD_LICENSE = 'UPLOAD_LICENSE';
export const UPLOAD_LICENSE_SUCCESS = 'UPLOAD_LICENSE_SUCCESS';
export const UPLOAD_LICENSE_FAIL = 'UPLOAD_LICENSE_FAIL';
export const UPLOAD_LICENSE_RESET = 'UPLOAD_LICENSE_RESET';

export const LICENSE_UPDATE_POST = 'LICENSE_UPDATE_POST';
export const LICENSE_UPDATE_POST_SUCCESS = 'LICENSE_UPDATE_POST_SUCCESS';
export const LICENSE_UPDATE_POST_FAIL = 'LICENSE_UPDATE_POST_FAIL';
export const LICENSE_UPDATE_PATCH = 'LICENSE_UPDATE_PATCH';
export const LICENSE_UPDATE_PATCH_SUCCESS = 'LICENSE_UPDATE_PATCH_SUCCESS';
export const LICENSE_UPDATE_PATCH_ERROR = 'LICENSE_UPDATE_PATCH_ERROR';
export const LICENSE_UPDATE_RESET = 'LICENSE_UPDATE_RESET';

export const AP_NOTIFICATION = 'AP_NOTIFICATION';
export const AP_NOTIFICATION_SUCCESS = 'AP_NOTIFICATION_SUCCESS';
export const AP_NOTIFICATION_FAIL = 'AP_NOTIFICATION_FAIL';

export const LICENSE_DETAILS_POPUP_REQUEST = 'LICENSE_DETAILS_POPUP_REQUEST';
export const LICENSE_DETAILS_POPUP_SUCCESS = 'LICENSE_DETAILS_POPUP_SUCCESS';
export const LICENSE_DETAILS_POPUP_FAILURE = 'LICENSE_DETAILS_POPUP_FAILURE';

export const LICENSE_UPDATE_POPUP_REQUEST = 'LICENSE_UPDATE_POPUP_REQUEST';
export const LICENSE_UPDATE_POPUP_SUCCESS = 'LICENSE_UPDATE_POPUP_SUCCESS';
export const LICENSE_UPDATE_POPUP_FAILURE = 'LICENSE_UPDATE_POPUP_FAILURE';